import { DrawerBase } from '../../../core/pixi/DrawerBase';
import { GameLayers } from '../../../enums/GameLayers';

export class GameDrawerBase extends DrawerBase {
  constructor(config) {
    super();
    this.config = config;
    this.layers = {
      [GameLayers.Background]: this.createContainer('Background'),
      [GameLayers.Characters]: this.createContainer('Characters'),
      [GameLayers.GamePad]: this.createContainer('GamePad'),
      *[Symbol.iterator]() {
        yield this[GameLayers.Background];
        yield this[GameLayers.GamePad];
        yield this[GameLayers.Characters];
      },
    };
  }

  __steLayerConfigs = (element) => {
    element.width = this.config.width;
    element.height = this.config.height;
  };

  setupLayers() {
    if (!this.layerSetupState) {
      this.layerSetupState = true;
      [...this.layers].forEach(this.__steLayerConfigs);
      this.parent.addChild(...this.layers);
    }
  }

  async execute({ scene, parent, prevScene }) {
    return new Promise((resolve) => {
      this.parent = parent;
      this.loadResource().then(() => {
        this.setupLayers();
        this.draw();
        resolve(true);
      });
    });
  }
}
